export function getTrailingDigits(value: string): string | undefined {
  const matchResult = value.match(/\d+$/);
  return matchResult != null ? matchResult[0] : undefined;
}

// mimics https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/padStart
// TODO: replace with polyfill?
export function padStart(str: string, targetLength: number, padString?: string) {
  // https://github.com/uxitten/polyfill/blob/master/string.polyfill.js
  // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/padStart
  // eslint-disable-next-line
  targetLength = targetLength >> 0; // floor if number or convert non-number to 0;
  // eslint-disable-next-line
  padString = String(padString || ' ');
  if (str.length > targetLength) {
    return String(str);
  } else {
    targetLength = targetLength - str.length;
    if (targetLength > padString.length) {
      padString += padString.repeat(targetLength / padString.length); // append to original to ensure we are longer than needed
    }
    return padString.slice(0, targetLength) + String(str);
  }
}

export function isNullOrEmpty(value: string | null | undefined) {
  return value == null || value === '';
}

export function isNullOrWhitespace(value: string | null) {
  return value == null || value.trim() === '';
}
